module.exports = __webpack_public_path__ + "img/lc.761f4ae3.svg";